import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectGroups = (state: RootState) =>
  state.rootReducer.groupsStore.groups;

export const selectIsLoadingGroups = (state: RootState) =>
  state.rootReducer.groupsStore.isLoadingGroups;

export const selectGroupsState = createSelector(
  selectGroups,
  selectIsLoadingGroups,
  (groups, isLoadingGroups) => ({
    groups,
    isLoadingGroups
  })
);
